import { Modal, Table } from "antd";
import React from "react";
import CustomTable from "../../../components/common/Table/CustomTable";
import ErrorDiv from "../../../components/helpers/ErrorDiv";
import { useState } from "react";
import NumberFormat from "react-number-format";
import { Button } from "react-bootstrap";
import { CurrencyFormat } from "../../../components/helpers";

export default function ModalSumulationInstallment({
    visible,
    onClose,
    data,
    loading,
    calculate,
    loanAmount,
    setLoanAmount,
    submitting,
    total,
}) {
    const column = [
        {
            dataIndex: "periode",
            key: "periode",
            title: "Periode",
            width: 60,
        },
        {
            dataIndex: "capitalLoan",
            key: "capitaLoan",
            title: "Biaya Sewa Modal",
        },
        {
            dataIndex: "installmentAmount",
            key: "installmentAmount",
            title: "Cicilan Pokok",
        },
        {
            dataIndex: "totalInstallment",
            key: "totalInstallment",
            title: "Total Cicilan",
        },
        {
            dataIndex: "remainingInstallment",
            key: "remainingInstallment",
            title: "Sisa Tagihan",
        },
    ]
    const [errorAmount, setErrorAmount] = useState()

    const validate = () => {
        setErrorAmount()
        if (!loanAmount || loanAmount < 1) {
            setErrorAmount('Jumlah pinjaman masih kosong')
            return
        }
        calculate()
    }

    return (
        <Modal
            title={"Simulasi Cicilan"}
            visible={visible}
            onCancel={onClose}
            width={800}
            centered
            footer={[
            ]}
        >
            <div className="my-2 d-flex align-items-center">
                <div>Masukkan Jumlah Pinjaman</div>
                <div className="mr-3">
                    <div className="ml-2 d-flex align-items-center">
                        <NumberFormat
                            prefix="Rp "
                            value={loanAmount}
                            isNumericString={true}
                            onValueChange={(e) => setLoanAmount(e.floatValue)}
                            thousandSeparator={"."}
                            decimalSeparator={","}
                            style={{
                                height: 36,
                                border: "0.75px solid #DCDCDC",
                                width: '100%',
                                paddingLeft: 6,
                                borderRadius: 6
                            }}
                        />
                    </div>
                    {errorAmount && <span className="text-danger small ml-2">{errorAmount}</span>}
                </div>
                <Button
                    disabled={submitting}
                    variant="primary"
                    className="btn-action btn-add ml-3"
                    style={{ width: 120, height: 36, margin: 5 }}
                    onClick={validate}
                >
                    Hitung
                </Button>
            </div>
            <CustomTable
                columns={column}
                data={data}
                loading={loading}
                summary={() =>
                    <Table.Summary >
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0}><span style={{ fontWeight: '700' }}>Total</span></Table.Summary.Cell>
                            <Table.Summary.Cell index={1}><span style={{ fontWeight: '700' }}>Rp {CurrencyFormat(total.capitalLoan)}</span></Table.Summary.Cell>
                            <Table.Summary.Cell index={1}><span style={{ fontWeight: '700' }}>Rp {CurrencyFormat(total.installmentAmount)}</span></Table.Summary.Cell>
                            <Table.Summary.Cell index={1}><span style={{ fontWeight: '700' }}>Rp {CurrencyFormat(total.totalInstallment)}</span></Table.Summary.Cell>
                            <Table.Summary.Cell index={1}><span style={{ fontWeight: '700' }}>-</span></Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                }
                // handleTableChange={handleTableChange}
                pagination={false}
            />
        </Modal>
    );
}
